import jsPDF from 'jspdf';
import { createPdf } from './createPdf';

export async function exportChartToPdf(chart) {
  const doc = new jsPDF('p', 'px');

  const elements = document.getElementsByClassName(chart);

  await createPdf(doc, elements);

  doc.save(`charts.pdf`);
}
